module.exports = __webpack_public_path__ + "static/health-aeb8c9f41d0dec816fcca13ef2fa9ce5.png";